export const content = {
  'designer.optimization.insights-panel.title': 'Insights',
  'designer.optimization.interaction-loss-in-variation-dialog.title':
    'Interaction will be disabled',
  'designer.optimization.interaction-loss-in-variation-dialog.body':
    "Editing an element that's part of an interaction will disable the interaction in this variant. You can keep the interaction by returning to the base site and making it target the element by a class instead.",
  'designer.optimization.base-variation-read-only.title': 'Read-only view',
  'designer.optimization.base-variation-read-only.body':
    'Exit the optimization to make changes to your base site.',
  'designer.optimization.settings.optimization-blocker.optimization-wrapper-with-base-in-optimize.body':
    'Content inside this block is changed in another variation.',
  'designer.optimization.settings.optimization-blocker.optimization-wrapper-with-treatment-in-optimize.body':
    'Content inside this block is changed in this variation.',
  'designer.optimization.settings.optimization-blocker.treatment-wrapper-in-optimize.title':
    'Variation edited',
  'designer.optimization.settings.optimization-blocker.treatment-wrapper-in-optimize.body':
    "Changes here won't sync with changes on the base site.",
  'designer.optimization.settings.optimization-blocker.base-wrapper-in-optimize.title':
    'Base site content',
  'designer.optimization.settings.optimization-blocker.base-wrapper-in-optimize.body':
    'Edit to make changes in this variation.',
  'designer.optimization.settings.optimization-blocker.optimization-wrapper-out-of-optimize.title':
    'Optimization block',
  'designer.optimization.settings.optimization-blocker.optimization-wrapper-out-of-optimize.body':
    'Content inside this block is changed in other variations. Deleting or moving it will affect them.',
  'designer.optimization.settings.optimization-blocker.base-wrapper-out-of-optimize.title':
    'Base block',
  'designer.optimization.settings.optimization-blocker.base-wrapper-out-of-optimize.body':
    'This block is replaced in other variations.',
  'designer.components.settings.optimization-blocker.forbidden-multiuser.title':
    'Optimization action not allowed',
  'designer.components.settings.optimization-blocker.forbidden-multiuser.body':
    "There's an active session designing in this page.",
};
